import { Button, Icon } from '@nazka/nazka.mapframe.components';
import './disclaimer.styl';
import { faClose } from '@fortawesome/pro-regular-svg-icons';

function Disclaimer({ setShow }) {
  return (
    <div className="disclaimer">
      <div
        className="disclaimer__background"
        onClick={() => setShow(false)}
      />
      <div className="disclaimer__content">
        <div className="disclaimer__content__header">
          <div className="disclaimer__content__header__title">
            <h2 className="disclaimer__content__header__title__text">
              Disclaimer
            </h2>
          </div>
          <Button
            icon={faClose}
            layout="ghost"
            hover={false}
            className="disclaimer__content__header__close"
            onClick={() => setShow(false)}
          />
        </div>
        <div className="disclaimer__content__body">
          <h4>Het mobiliteitsaanbod van een onderneming</h4>
          <p>
            Het mobiliteitsaanbod geeft een beeld van het algemene mobiliteitsbeleid van een bedrijf. 
            Sommige mobiliteitsvoordelen zijn mogelijk niet voor elke werknemer van toepassing, maar eerder 
            {'functie- of jobgebonden. Het overzicht dat op '}
            <a 
              href="https://naarjobs.be"
              target="_blank"
              rel="noopener noreferrer"
            >
              naarjobs.be
            </a>
            {' staat, is een overzichtelijke '}
            voorstelling zonder formele verbintenis. Relevante mobiliteitsvoordelen per specifieke 
            job worden vermeld via de VDAB vacature en/of tijdens het kennismakingsgesprek.
          </p>
          <h4>Oorsprong van de mobiliteitsgegevens</h4>
          <p>
            Een deel van de mobiliteitsgegevens die je hier terugvindt, zijn ontleend aan de Federale 
            Diagnostiek Mobiliteit (
            <a 
              href="https://mobilit.belgium.be/nl/mobiliteit/woon_werkverkeer"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://mobilit.belgium.be/nl/mobiliteit/woon_werkverkeer
            </a>
            ). Als 
            ondernemer kan je ook inloggen op het admin-luik van NaarJobs en zelf informatie toevoegen. 
            De gegevens van de Federale Diagnostiek Mobiliteit zijn hier, indien beschikbaar, al vooraf 
            ingevuld. Deze moeten dus nagekeken worden, want mogelijk zijn deze gegevens ondertussen 
            verouderd, of slopen er fouten in bij het invullen van de vragenlijst van de Federale 
            Diagnostiek Mobiliteit.
          </p>
          <p>
            Wanneer er voor jouw onderneming geen data beschikbaar zijn vanuit de Federale Diagnostiek 
            Mobiliteit, zijn er ook geen data vooringevuld bij de registratie van je mobiliteitsgegevens. 
            In dat geval gaan we er vanuit dat je onderneming geen mobiliteitsvoordelen aanbiedt. Het is 
            dan aan jou om dit in ons systeem volledig in te vullen.
          </p>
          <p>
            Ondernemingen die hun mobiliteitsdata afkomstig van de Federale Overheidsdienst Mobiliteit en 
            Vervoer liever niet op het platform gepubliceerd zien, kunnen dit op elk moment aangeven door 
            {'contact op te nemen via '}
            <a 
              href="mailto:info@nazka.be"
            >
              info@nazka.be
            </a>
            {' of door in te loggen en hun gegevens te vewijderen.'}
          </p>
          <h4>Naam van de onderneming en de vestigingen</h4>
          <p>
            De namen die getoond worden voor ondernemingen en vestigingen, zijn ontleend aan de databanken 
            van de Kruispuntbank van Ondernemingen (KBO) en de Verrijkte Kruispuntbank Ondernemingen (VKBO). 
            {'De weergegeven namen zijn in geen geval beheerd door '}
            <a 
              href="https://naarjobs.be"
              target="_blank"
              rel="noopener noreferrer"
            >
              naarjobs.be
            </a>
            {' zelf.'}
          </p>
          <p>
            Mocht je toch een naamswijziging aan de Kruispuntbank van Ondernemingen (KBO) willen doorgeven, 
            {'dan kan je dit doen via deze link: '}
            <a 
              href="https://economie.fgov.be/nl/themas/ondernemingen/kruispuntbank-van/my-enterprise/kruispuntbank-van"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://economie.fgov.be/nl/themas/ondernemingen/kruispuntbank-van/my-enterprise/kruispuntbank-van
            </a>
            . 
            Bemerk wel dat het een aantal maanden kan duren eer deze naamswijziging is doorgevoerd, en dus ook 
            eer ons systeem de correcte naam toont.
          </p>
          <h4>Adressen van de jobs</h4>
          <p>
            Nazka neemt de adressen van de jobs niet gewoon over van de VDAB, maar verrijkt de VDAB-gegevens met 
            behulp van een engine. Zo proberen we jobs juist op de kaart te tonen.
          </p>
          <p>
            Voor jobs zonder volledig ingevuld &apos;tewerkstellingsadres&apos; is dit vaak moeilijk. Vaak worden 
            jobs gepost door intermediairen en derdeleveranciers en willen of kunnen ze deze gegevens 
            niet delen. Een intelligent algoritme verbetert en gevalideert de gegevens die we krijgen 
            en doet zo een poging veel jobs toch op de kaart te krijgen.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer;